
























import { defineComponent, toRefs, PropType, computed } from '@vue/composition-api';
import { AdgroupConfig, brandDataTrack } from '@tt4b/ttam-enums';
import PromotionBrandTrackType from './index';

const name = 'ttam-promotion-brand-track-type-compose';
export default defineComponent({
  name,
  components: {
    TtamPromotionBrandTrackTypeIsEnable: PromotionBrandTrackType.TtamPromotionBrandTrackTypeIsEnable,
    TtamPromotionBrandTrackType: PromotionBrandTrackType.TtamPromotionBrandTrackType,
  },
  props: {
    adgroupConfig: {
      type: Object as PropType<AdgroupConfig>,
      default: () => ({}),
    },
    trackType: {
      type: Number,
      default: () => brandDataTrack.pixelTrack,
    },
    isTrackTypeEnable: {
      type: Boolean,
      default: false,
    },
  },
  setup(props, { emit }) {
    const { adgroupConfig } = toRefs(props);
    const isBrandTrackTypeDisabled = computed(() => adgroupConfig.value.disableBrandTrack);
    const { list: typeList } = PromotionBrandTrackType.useBrandTrackTypePropsList();
    const onEnableInput = (val: boolean) => {
      emit('is-enable-change', val);
    };
    const onTypeInput = (val: number) => {
      emit('type-change', val);
    };

    return {
      name,
      typeList,
      isBrandTrackTypeDisabled,
      onTypeInput,
      onEnableInput,
    };
  },
});
